import { render } from "./AddPersonManual.vue?vue&type=template&id=c3f24508"
import script from "./AddPersonManual.vue?vue&type=script&lang=js"
export * from "./AddPersonManual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__